import { Grid } from '@mui/material';
import { SlideParagraph, SlideSubtitle, SlideTitle } from 'features/slides';
import React from 'react';
import styles from './styles.module.css';
import foto1 from './foto1.png';
import foto2 from './foto2.png';
import foto3 from './foto3.png';

export function AMKProfiles(): React.ReactElement {
  return (
    <Grid container direction="column" spacing={2} className={styles.container}>
      <Grid item>
        <SlideTitle style={{ paddingBottom: '10px' }}>
          About AssetMark Investment Consulting
        </SlideTitle>
        <SlideParagraph style={{ paddingBottom: '10px' }}>
          AssetMark’s Investment Consulting team works with advisors as an
          expansion of their team, providing guidance around investment-related
          topics, including the creation of investment models to improve the
          efficiency of an advisor&apos;s practice.
        </SlideParagraph>
      </Grid>
      <Grid item sx={{ paddingTop: '0px !important' }}>
        <SlideSubtitle style={{ paddingBottom: '10px' }}>
          Team members are:
        </SlideSubtitle>
        <Grid
          container
          direction="row"
          spacing={2}
          sx={{ paddingBottom: '12px' }}
        >
          <Grid item xs={12} md={3}>
            <Grid item sx={{ width: '160px', height: '160px' }}>
              <img src={foto1} alt="foto1" style={{ width: '100%' }} />
            </Grid>
          </Grid>
          <Grid item xs={12} md={9}>
            <SlideParagraph style={{ fontWeight: '600' }}>
              Zoë Brunson, CFA
            </SlideParagraph>
            <SlideParagraph style={{ fontWeight: '500', marginBottom: '6px' }}>
              Chief Investment Strategist, SVP, Platform Investment Strategies
            </SlideParagraph>
            <SlideParagraph style={{ fontSize: '14px', marginBottom: '6px' }}>
              Zoë oversees the Platform Investment Strategies Group. She is
              responsible for overseeing all due diligence on investment
              strategists on the AssetMark platform and AssetMark’s investment
              consulting services.
            </SlideParagraph>
            <SlideParagraph style={{ fontSize: '14px' }}>
              Zoë has over 25 years’ experience and joined AssetMark in 2007.
              Previously Zoë was at Standard & Poor’s where she led the
              investment advisory services team responsible for manager due
              diligence and creation of multi-manager strategies.
            </SlideParagraph>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          spacing={2}
          sx={{ paddingBottom: '12px' }}
        >
          <Grid item xs={12} md={3}>
            <Grid item>
              <img src={foto2} alt="foto2" style={{ width: '100%' }} />
            </Grid>
          </Grid>
          <Grid item xs={12} md={9}>
            <SlideParagraph style={{ fontWeight: '600' }}>
              Rob Carlen
            </SlideParagraph>
            <SlideParagraph style={{ fontWeight: '500', marginBottom: '6px' }}>
              VP, Investment Consulting
            </SlideParagraph>
            <SlideParagraph style={{ fontSize: '14px', marginBottom: '6px' }}>
              Rob is responsible for leading our investment consulting efforts
              providing guidance to advisors through building portfolios on the
              AssetMark platform, including selecting the right investment
              managers and providing objective risk-based analysis, research,
              and insights
            </SlideParagraph>
            <SlideParagraph style={{ fontSize: '14px' }}>
              Rob has over 20 years’ experience and joined AssetMark in 2025.
              Previously, Rob spent 17 years at Northern Trust Asset Management
              where he worked in their OCIO practice and most recently led the
              NTAM Investment Institute, where he was responsible for providing
              advisors with thought leadership and investment consulting
              services.
            </SlideParagraph>
          </Grid>
        </Grid>
        <Grid container direction="row" spacing={2}>
          <Grid item xs={12} md={3}>
            <Grid item>
              <img src={foto3} alt="foto3" style={{ width: '100%' }} />
            </Grid>
          </Grid>
          <Grid item xs={12} md={9}>
            <SlideParagraph style={{ fontWeight: '600' }}>
              Keith Parker, CFA
            </SlideParagraph>
            <SlideParagraph style={{ fontWeight: '500' }}>
              Investment Consultant
            </SlideParagraph>
            <SlideParagraph style={{ fontSize: '14px', marginBottom: '6px' }}>
              Keith Parker provides investment consulting to guide advisors
              through building portfolios on the AssetMark platform, including
              selecting the right investment managers and providing objective
              risk-based analysis, research, and insights.
            </SlideParagraph>
            <SlideParagraph style={{ fontSize: '14px' }}>
              Keith has over 25 years’ experience and joined AssetMark in 2022.
              Prior to joining AssetMark, Keith spent 8 years as a Senior
              Investment Analyst at the Wells Fargo Investment Institute, 5
              years as a Senior Fund Analyst/Product Specialist for HighMark
              Capital Management, and 3 years as a Senior Analyst for the Schwab
              Center for Financial Research.
            </SlideParagraph>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
